const IMG_SERVER_URL =
  process.env.NODE_ENV !== "production"
    ? "http://thumbor.mumu.agency"
    : "https://my.ethosfarm.com/thumbor";

// export default (url, w, h) => `${IMG_SERVER_URL}/?url=${url}&w=${w}&h=${h}&mode=adapt&op=rotate,resize&deg=auto`

export default (url, w, h) =>
  `${IMG_SERVER_URL}/unsafe/fit-in/${w}x${h}/${url}`;
